export const deleteSimbolFromNumber = (num) => {
  if (!num) {
    return null;
  }
  return num.replace(/[\s+().,%]/g, "");
};
